import request from '@/config/axios'
export const getVideoPage = (params: any) => request.get({ url: '/short-video/video/page', params })
export const createVideo = (data: any) => request.post({ url: '/short-video/video/create', data })
export const updateVideo = (data: any) => request.put({ url: '/short-video/video/update', data })
export const deleteVideo = (id: number) =>
  request.delete({ url: '/short-video/video/delete', params: { id } })
export const publishVideo = (id: number) =>
  request.post({ url: '/short-video/video/publish', params: { id } })
export const offlineVideo = (id: number) =>
  request.post({ url: '/short-video/video/offline', params: { id } })
